import ApiClient from '@/services/apiClient';
import AccessReader from '@/models/accessReader';

// A Haxo Booking room: a label and the readers that give access to it, on one
// or several hubs / LINKs of the installation. The backend keeps a phantom
// access group (group_id) in step with the readers; managers never see it.
export default class Room {
    id;
    facility_id;
    group_id;
    label;
    readers;

    constructor(id = 0, label = "") {
        this.id = id;
        this.label = label;
        this.readers = [];
    }

    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Room();
            obj.id = ApiClient.convertToType(data['id'], 'Integer');
            obj.facility_id = ApiClient.convertToType(data['facility_id'], 'Integer');
            obj.group_id = ApiClient.convertToType(data['group_id'], 'Integer');
            obj.label = ApiClient.convertToType(data['label'], 'String');
            obj.readers = ApiClient.convertToType(data['readers'], [AccessReader]) || [];
        }
        return obj;
    }

    get reader_ids() {
        return this.readers.map(reader => reader.id);
    }

    // What the API takes to create or update a room
    toJSON() {
        return {
            label: this.label,
            reader_ids: this.reader_ids,
        };
    }

    toString() {
        return this.label;
    }
}
